

 <div class="date-filter ">
    <p class="close_button" (click)="closeDialog()">x</p>
     <div class="from-row">
         <label class="from-label " >From:</label>

            <input class="from-date" type="date" [(ngModel)]="selectedFromDate">

       </div><br>
     <div class="to-row">
        <label class="to-label" >To:</label>
          <input class="to-date" type="date" [(ngModel)]="selectedToDate">

      </div>
       <br>
      <div class="apply-button">
        <button style="color: white;"><p class="btn-text" (click)="submit()">Apply </p></button>
        </div>
 </div>

